// src/components/property-spaces/property-spaces.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query PropertySpacesQuery($context: ContextInput!, $propertyId: String!) {\n    summary: propertySpaces(context: $context, propertyContentType: SUMMARY, propertyId: $propertyId) {\n      ...PropertyContentSectionGroupFragment\n    }\n    detailed: propertySpaces(context: $context, propertyContentType: DETAILED, propertyId: $propertyId) {\n      ...PropertyContentSectionGroupFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { PropertyContentSection, PropertyContentSectionDetailedDialogContext, PropertyContentSectionGroup } from "@shared-ui/lodging-fragments";
var __Query = gql(_templateObject(), PropertyContentSectionGroup.fragment);
var PropertySpaces = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, _param_actionId = param.actionId, actionId = _param_actionId === void 0 ? "spaces" : _param_actionId;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr,
        errorPolicy: "all"
    }), data = _useQuery.data, loading = _useQuery.loading;
    var _useState = _sliced_to_array(useState(null), 2), idReference = _useState[0], setIdReference = _useState[1];
    var detailedDialogContent = React.useMemo(function() {
        var _data_detailed_sections, _data_detailed;
        var dialogElement = /* @__PURE__ */ React.createElement(React.Fragment, null, data === null || data === void 0 ? void 0 : (_data_detailed = data.detailed) === null || _data_detailed === void 0 ? void 0 : (_data_detailed_sections = _data_detailed.sections) === null || _data_detailed_sections === void 0 ? void 0 : _data_detailed_sections.map(function(section, index) {
            return /* @__PURE__ */ React.createElement(PropertyContentSection, {
                data: section,
                columns: 1,
                key: "detailed-section-".concat(index),
                isInDialog: true,
                actionId: actionId
            });
        }));
        return {
            dialogElement: dialogElement,
            actionId: actionId,
            idReference: idReference,
            setIdReference: setIdReference
        };
    }, [
        data === null || data === void 0 ? void 0 : data.detailed,
        idReference
    ]);
    if (loading || !data) {
        return null;
    }
    var summary = data.summary;
    if (!summary) {
        return null;
    }
    return /* @__PURE__ */ React.createElement(PropertyContentSectionDetailedDialogContext.Provider, {
        value: detailedDialogContent
    }, /* @__PURE__ */ React.createElement(PropertyContentSectionGroup, {
        data: summary,
        columns: 1,
        actionId: actionId
    }));
};
PropertySpaces.displayName = "sharedui-PropertySpaces";
export { PropertySpaces };
//# sourceMappingURL=index.js.map